/**
 *
 * Blog UI
 *
 * instantiates all mixitup and handles events with the user interface
 */

const $ = require('jquery')

class BlogUI {
  constructor (el) {
    this.$el = $(el)

    this.mobileControls = this.$el.find('.itbl-c-blog__mobile-toggle')
    this.topicsContainer = this.$el.find('.itbl-c-blog__controls-topics')
    this.searchContainer = this.$el.find('.itbl-c-blog__controls-search')

    this.jpListSearch = this.$el.find('#toggle-search')
    this.jpListSearch__input = this.jpListSearch
      .find('.itbl-b-searchbox__input')
    this.jpListSearch__clear = this.jpListSearch
      .find('.itbl-b-searchbox__clear')
    this.jpListSearch__submit = this.jpListSearch
      .find('.itbl-b-searchbox__submit')
    this.jpListNoResults = this.$el.find('.itbl-c-blog__no-results-query')

    // this.listFilters = this.$el.find('[data-jplist-control]')
    //   .map(function () {
    //     if (typeof $(this).data('path') !== 'undefined') {
    //       return $(this)
    //         .data('path')
    //         .replace(/\./g, '')
    //     }
    //   }).get()

    this.jplistClass = this.$el.find('.itbl-c-blog__controls-topic')

    this.$smoothScroll = $(document).find('.itbl-u-jump-down')

    this.controlsOffSet = null
    this.jpList = null

    // default scroll settings - note tho -- we need to calculate the height of the sticky menu each time smooth scroll runs
    this.scrollSettings = {
      threshold: 50,
      offset: 110,
      animationDuration: 550
    }

    //init jplist
    this.jpList = window.jplist.init()

    //events
    this.events()
  }

  events () {
    this.mobileControls.on(
      'click',
      this.event__toggleControlsOnMobile.bind(this)
    )
  }

  event__toggleControlsOnMobile (event) {
    event.preventDefault()

    $(this.topicsContainer).toggle()
    $(this.searchContainer).toggle()
  }
}

$(document).ready(function () {
  $('.itbl-c-blog__container').each(function () {
    new BlogUI(this)
  })
})
